import {Tabs, styled, Tab} from '@mui/material';
import {Box} from '@jobseeker/lotus/foundations';

import type {StyleTabProp, StyleTabsProp, StyledSpanProps} from './types';

const StyledTabs = styled<any>((props: StyleTabsProp) => <Tabs {...props} />)(
  ({theme}) => ({
    '& div.MuiTabs-scroller': {
      '& .MuiTabs-flexContainer': {
        '@media (width:1280px)': {
          gap: theme.spacing(1.5),
        },
        gap: theme.spacing(2),
      },
    },
  })
);

const StyledTab = styled<any>((props: StyleTabProp) => (
  <Tab disableRipple {...props} />
))(({theme}) => ({
  color: theme.palette.secondary.main,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs' ? 500 : 600,
  ':hover': {
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  opacity: 1,
  alignItems: 'flex-start',
  wordWrap: 'break-word',
  padding: 0,
  minWidth: 0,
  whiteSpace: 'nowrap',
  minHeight: theme.spacing(7.5),
}));

const StyledSpan = styled<any>((props: StyledSpanProps) => (
  <Box component="span" {...props} />
))(({theme, visible}) => ({
  display: 'block',
  backgroundColor: visible ? theme.palette.primary.main : '',
  width: theme.spacing(3.75),
  height: theme.spacing(0.5),
  marginLeft: 'auto',
  marginRight: 'auto',
  borderRadius: theme.spacing(0.5),
}));

export {StyledTabs, StyledTab, StyledSpan};
